import * as React from 'react';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import './DamageClaimInfo.scss';

// Style and misc imports

import { any, element } from 'prop-types';
import UserModel from 'src/model/user.model';

class DamageClaimInfo extends React.Component<IDamageClaimInfoProps, any> {
  constructor(props: IDamageClaimInfoProps) {
    super(props);
  }

  public render() {
    return (
      <>
        <h4>{i18n.t('damageClaim.claiminfo')}</h4>

        <div className="form-row row  DamageClaimInfo">
          <div className="form-group col-sm-12 col-md-4 col-lg-3  mb">
            <label
              className="form-control-placeholder"
              htmlFor="customernumber"
            >
              {i18n.t('partClaim.customerNumber')}:
            </label>
            <input
              className={`form-control grey-color`}
              name="customerNumber"
              type="text"
              value={this.props.DamageCustomerNumber}
              readOnly={true}
            />
          </div>

          <div className="form-group col-sm-12  col-md-4 col-lg-3 mb">
            <label className="form-control-placeholder" htmlFor="claimnumber">
              {i18n.t('partClaim.claimNumber')}:
            </label>
            <input
              type="text"
              className={`form-control grey-color`}
              name="claimNumber"
              value={this.props.DamageClaimNumber}
              readOnly={true}
            />
          </div>
          <div className="form-group col-sm-12 col-md-6 col-lg-3">
            <label className="form-control-placeholder" htmlFor="refno">
              {i18n.t('partClaim.refno')}:
            </label>
            <input
              type="text"
              className={`form-control ${
                this.props.DamageErrorlist?.DamagerefnoError ? 'is-invalid' : ''
              }`}
              name="refno"
              value={this.props.DamageRefnoNumber}
              onChange={this.props.handleDamageRefNumber}
            />

            <span className="rp-warranty-input-error-internal">
              {this.props.DamageErrorlist?.DamagerefnoError
                ? this.props.DamageRefnoNumber.length > 30
                  ? `${i18n.t('partClaim.maxref')}`
                  : `${i18n.t('partClaim.invref')}`
                : ''}
            </span>
          </div>
        </div>
      </>
    );
  }
}

export default DamageClaimInfo;

interface IDamageClaimInfoProps {
  DamageCustomerNumber: string;
  DamageClaimNumber: string;
  DamageRefnoNumber: string;
  DamageErrorlist: any;
  DamageErrormsgshow: boolean;
  handleDamageRefNumber: (event: any) => void;
}
